import "core-js/modules/es.string.replace.js";

const isCanvasBlacklisted = () => {
  if (typeof window === 'undefined') {
    return true;
  }

  const {
    userAgent
  } = window.navigator;
  return userAgent.includes('jsdom');
};

const getCanvasContext = (() => {
  // @ts-expect-error - TS7034 - Variable 'canvas' implicitly has type 'any' in some locations where its type cannot be determined.
  let canvas = null; // @ts-expect-error - TS7034 - Variable 'context' implicitly has type 'any' in some locations where its type cannot be determined.

  let context = null;
  let err = isCanvasBlacklisted();
  return () => {
    if (err) {
      return null;
    } // Jest will throw an error on canvas.getContext('2d').
    // We may want to mock this or use a canvas implementation in the future.


    try {
      // @ts-expect-error - TS7005 - Variable 'canvas' implicitly has an 'any' type.
      canvas = canvas || document.createElement('canvas'); // @ts-expect-error - TS7005 - Variable 'context' implicitly has an 'any' type.

      context = context || canvas.getContext('2d');
      return context;
    } catch (e) {
      err = e;
    }

    return null;
  };
})();

const getCanvasFontString = ({
  size,
  family,
  weight
}) => `${weight} ${size}px ${family}`;

const getFontWidth = ({
  text,
  size,
  family,
  weight
}) => {
  const ctx = getCanvasContext();

  if (!ctx || !ctx.measureText) {
    return 0;
  }

  ctx.font = getCanvasFontString({
    size,
    family,
    weight
  }); // Include safety checks to avoid errors.
  // See https://jira.corp.stripe.com/browse/SAIL-1636

  const measurements = ctx.measureText(text);
  return measurements && measurements.width || 0;
};

const hasFont = ({
  family,
  size,
  text,
  weight
}) => {
  const fallbacks = ['sans-serif', 'serif', 'monospace'];
  return fallbacks.some(fallback => {
    const fallbackWidth = getFontWidth({
      text,
      size,
      family: fallback,
      weight
    });
    const width = getFontWidth({
      text,
      size,
      family: [family, fallback].join(', '),
      weight
    });
    return width !== fallbackWidth;
  });
};

export const getComputedFont = ({
  family,
  size = 128,
  text = 'Sail',
  weight = 400
}) => {
  const parts = family.split(',').map(name => name.trim().replace(/^"/, '').replace(/"$/, ''));
  return parts.find(part => {
    return hasFont({
      family: part,
      size,
      text,
      weight
    });
  }) || '';
};